import { render, staticRenderFns } from "./CYSyueChengBen.vue?vue&type=template&id=1acb8672&scoped=true&"
import script from "./CYSyueChengBen.vue?vue&type=script&lang=js&"
export * from "./CYSyueChengBen.vue?vue&type=script&lang=js&"
import style0 from "./CYSyueChengBen.vue?vue&type=style&index=0&id=1acb8672&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb8672",
  null
  
)

export default component.exports